export default __webpack_public_path__ + "static/media/Logo-helppeople-2021-favicon.8bb0c443.png";